module.exports = __webpack_public_path__ + "static/media/check-w.f6e8ba69.svg";